var $0a1b42c97638052f$exports = {};
$0a1b42c97638052f$exports = {
    "loading": `Laadimine...`,
    "loadingMore": `Laadi rohkem...`
};


export {$0a1b42c97638052f$exports as default};
//# sourceMappingURL=et-EE.module.js.map
